import React from 'react';

type Alignments = 'center' | 'left' | 'right';
type RenderFunction<T> = (arg: T, index: number) => string | React.ReactNode;

type Params<T> = {
  label: React.ReactNode;
  align: Alignments;
  render: RenderFunction<T>;
  onSort?: (coluna: Coluna<T>, direction: 'asc' | 'desc') => void;
  show?: boolean;

  // backgroundColor?: string;
};

export default class Coluna<T> {
  align: Alignments;
  label: React.ReactNode;
  render: RenderFunction<T>;
  show?: boolean;

  onSort?: (coluna: Coluna<T>, direction: 'asc' | 'desc') => void;
  // backgroundColor?: string;

  constructor(params: Params<T>) {
    this.align = params.align;
    this.label = params.label;
    this.render = params.render;
    this.onSort = params.onSort;
    this.show = params.show ?? true;
    // // this.backgroundColor = params.backgroundColor;
  }
}
